import getI18nInstance from '@shared/i18nFactory';

const i18nInstance = getI18nInstance('353318');

export default i18nInstance;
